/* eslint-disable @typescript-eslint/no-explicit-any */
import { useId, Option } from '@fluentui/react-components';
import {
  AlertIcon,
  FormSectionTitle,
  StyledDropdown,
  OptionsWrapper,
} from './styles/common.styled';
import { OptionSet } from 'src/tabs/models/SkillsInterfaces';
import { Control } from 'react-hook-form/dist/types/form';
import {
  Controller,
  FieldError,
  FieldErrorsImpl,
  Merge,
  RegisterOptions,
} from 'react-hook-form';
import {
  ChatBubblesQuestion20Regular,
  Clipboard20Regular,
  FluentIcon,
  Warning20Regular,
} from '@fluentui/react-icons';
import { useEffect, useRef, useState } from 'react';

interface FormDropdownProps {
  options: OptionSet[];
  labelId: string;
  title: string;
  placeholder: string;
  control: Control<any>;
  controlName: string;
  rules: RegisterOptions<any, string>;
  error: Merge<
    FieldError,
    FieldErrorsImpl<{
      label: string;
      value: string;
    }>
  >;
  name: string;
}

interface CustomOptionProps {
  option: OptionSet;
  icon: FluentIcon;
}

export const FormDropdown = ({
  options,
  labelId,
  title,
  placeholder,
  control,
  controlName,
  rules,
  error,
  name,
}: FormDropdownProps) => {
  const ariaLabel = useId(labelId);
  const dropDownsRef = useRef(null);
  const [dropdownWidth, setDropdownWidth] = useState();
  useEffect(() => {
    setDropdownWidth(dropDownsRef?.current?.getBoundingClientRect()?.width);
  }, []);

  return (
    <>
      <FormSectionTitle htmlFor={ariaLabel} isRequired>
        {error && <AlertIcon />}
        {title}
      </FormSectionTitle>
      <Controller
        control={control}
        name={controlName}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <StyledDropdown
            ref={dropDownsRef}
            error={error}
            aria-required
            id={ariaLabel}
            value={value.label}
            name={name}
            defaultValue={value.label}
            onOptionSelect={(_, event) =>
              onChange({ value: event.optionValue, label: event.optionText })
            }
            selectedOptions={[value.value]}
            appearance="filled-darker"
            aria-labelledby={ariaLabel}
            placeholder={placeholder}
            listbox={{
              style: {
                maxHeight: '250px',
                width: `${dropdownWidth}px`,
              },
            }}
          >
            <OptionsWrapper>
              {options.map((option) => (
                <CustomOption
                  key={option.value}
                  option={option}
                  icon={optionIcons[option.label] ?? null}
                />
              ))}
            </OptionsWrapper>
          </StyledDropdown>
        )}
      />
    </>
  );
};

const CustomOption = ({ option, icon }: CustomOptionProps) => {
  const Icon = icon;
  return (
    <Option
      checkIcon={{ style: { color: '#5B5FC7' } }}
      text={option.label}
      value={option.value}
      key={option.value}
    >
      {Icon && <Icon />}
      <span>{option.label}</span>
    </Option>
  );
};

const optionIcons = {
  'Internal Task': Clipboard20Regular,
  Request: ChatBubblesQuestion20Regular,
  Incident: Warning20Regular,
};
